import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=52680316&"
import script from "./Step4.vue?vue&type=script&lang=js&"
export * from "./Step4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52680316')) {
      api.createRecord('52680316', component.options)
    } else {
      api.reload('52680316', component.options)
    }
    module.hot.accept("./Step4.vue?vue&type=template&id=52680316&", function () {
      api.rerender('52680316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/Step4.vue"
export default component.exports